import React, { useCallback } from 'react';

import {
  Container,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import configAlert from '../../../../assets/configuration.png';
import DirectRoutingConfigDialog from './DirectRoutingConfigDialog';
import { useState } from 'react'
import { serviceSliceState, setConfiguration } from '../../../../store/slice/serviceSlice';
import { useDispatch, useSelector } from 'react-redux';
import { executeWithTryCatch, gettingCompanyId, isResponseSuccess, normalizeApiResponse } from '../../../../helpers/HelperFunctions';
import { getCustomerConfiguration } from '../../../../api/get/getApi';
import { useToastContext } from '../../../../App';
import { ORDER_STATUS_ENUM, TOAST_MESSAGES } from '../../../../helpers/Constants';
import TenantProvisioning from '../common/TenantProvisioning';
import { useServiceRedux } from '../Services';
import DirectRoutingLegacyConfigDialog from './DirectRoutingLagecyConfiguration';


export default function DirectRoutingConfigurationAlert(props) {
  const [showConfig, setShowConfig] = useState(false);
  const state = useSelector(serviceSliceState);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { toast } = useToastContext();
  const [showTenantConfig, setShowTenantConfig] = useState(false)
  const { state: serviceState } = useServiceRedux();
  const [openLegacyConfForm, setOpenLegacyConfForm] = useState(false);
  const [isProvisioningStarting, setIsProvisioningStarting] = useState(false);



  const handleConfigChange = () => {
    setShowConfig(false);
    props.onConfigDataChange();
  }

  const openDirectRoutingConfigDialog = () => {
    if (state.selectedOrderService?.orderStatus == ORDER_STATUS_ENUM.Pending) {
      toast.showToast(TOAST_MESSAGES.PleaseWaitOrderActivation, 'error');
      return;
    }
    setShowConfig(true);
    executeWithTryCatch(getConfigurationDetails, handleGetConfigError)
  }

  const getConfigurationDetails = async () => {
    const response = await getCustomerConfiguration(gettingCompanyId());
    if (isResponseSuccess(response)) {
      dispatch(setConfiguration({
        ...response.data.result,
        userName: response.data.result.username,
        aadTenantId: response.data.result.aadTenantId
      }))
    }
    setIsLoading(false)
  }

  const handleGetConfigError = (error) => {
    setIsLoading(false)
    toast.showToast(normalizeApiResponse(error)?.message, 'error');
  }

  const renderConfigDialog = useCallback(() => {
    return (
      <DirectRoutingConfigDialog
        onClose={() => setShowConfig(false)}
        onChange={handleConfigChange}
        isLoading={isLoading}
        goToServiceFunction={props?.goToServiceFunction}
      />
    );
  }, [state.configuration, isLoading]);

  return (
    <Container maxWidth="xl" maxHeight="xl"
      style={{ textAlign: 'center', padding: '20px' }}>
      {!showTenantConfig ? (
        <>
          <div style={{ marginTop: '5%' }}>
            <img
              src={configAlert}
              alt="Configuration Alert"
              style={{
                maxWidth: '400px',
                maxHeight: '400px',
              }}
            />
          </div>
          <Typography variant="h3" component="h3" style={{ margin: '20px 0' }}>
            Configuration Incomplete
          </Typography>
          <Typography variant="subtitle1" gutterBottom component="div" style={{ marginBottom: '20px' }}>
            Please click the button below to configure your details.
          </Typography>
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <Button variant="contained"
              // onClick={openDirectRoutingConfigDialog}
              onClick={() => setShowTenantConfig(true)}
            >
              Administrate
            </Button>
          </div>
        </>
      ) : (
        <div style={{ padding: '20px' }}>
          <TenantProvisioning
            details={props?.details}
            // handleGetDetails={getSummary}
            serviceName={props.showWizardName?.name}
            onAdministrate={() => {
              if (
                serviceState?.selectedOrderService?.orderStatus ===
                ORDER_STATUS_ENUM.Pending
              ) {
                toast.showToast(
                  TOAST_MESSAGES.PleaseWaitOrderActivation,
                  'error'
                )
                return
              }
              setOpenLegacyConfForm(true)
            }}
            configDataLoading={props.configDataLoading}
            showTenantConfig={setShowTenantConfig}

            configData={props.configData}
            updateAdministrate={true}
            goToServiceFunction={props?.goToServiceFunction}
            setOpenLegacyConfForm={setOpenLegacyConfForm}
            setIsProvisioningStarting={setIsProvisioningStarting}
          />
        </div>
      )}

      {/* {showConfig &&
        <Grid container sx={{ width: '100%' }}>
          {renderConfigDialog()}
        </Grid>
      } */}

      {openLegacyConfForm && (
        <DirectRoutingLegacyConfigDialog
          isProvisioningStarting={isProvisioningStarting}
          onClose={() => {
            setOpenLegacyConfForm(false);
            setIsProvisioningStarting(false)
          }}
          onChange={handleConfigChange}
          configData={props.configData}
          serviceName={props.showWizardName?.name}
          updateAdministrate={true}
          goToServiceFunction={props?.goToServiceFunction}
          refreshPage={true}
        />
      )}
    </Container>
  );
}
